
import React from 'react';
import { connect } from 'react-redux';
import {DashboardContainer, GreyBox, TextLoading} from "../../../funcs/utils";
import {RadioButton} from "../../../../lib/prm/radio-button";
import {Name} from "../../../../lib/prm/name";
import {Text} from "../../../../lib/prm/text";
import {FlowRender} from "../../../../lib/flow-render";
import {DwollaTOS} from "../../../../lib/dwolla/widgets";
import { Action } from "../../../funcs/utils";
import { updateUserName } from "../../../login/login/actions";

const DWOLLA_CHECKBOX = new RadioButton(
  new Name("DWOLLA_CHECKBOX"),
  [
    new Name("tos_pp"),
  ]
);
DWOLLA_CHECKBOX.do_checkbox = true;

const FIRST_NAME = new Text(new Name("FIRST_NAME", "First Name"));
const LAST_NAME = new Text(new Name("LAST_NAME", "Last Name"));
const EMAIL = new Text(new Name("EMAIL", "Email"));

const ALL_PRMS = new FlowRender(0, [
  DWOLLA_CHECKBOX,
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
]);

const is_dirty = (user, state) => {
  if (user.first_name !== FIRST_NAME.getValue(state)) {
    return true;
  }
  if (user.last_name !== LAST_NAME.getValue(state)) {
    return true;
  }
  return false;
}


const on_create = component => () => {

  const user = component.props.user;
  let update_promise;
  if (is_dirty(user, component.state)) {
    const first_name = FIRST_NAME.getValue(component.state);
    const last_name = LAST_NAME.getValue(component.state);
    update_promise = updateUserName(
      component.props.user.token, null, first_name, last_name);
    component.props.updateUserNameRedux(first_name, last_name);
  } else {
    update_promise = Promise.resolve();
  }
  update_promise.then(() => {
    component.createCustomer();
  })
}

const CreateCustomer_ = props => {

  const component = props.component;

  const dump_text = prm => prm.renderInputDiv(
    component, { width: "100%"}, prm.name.label);
  const disable_command = !DWOLLA_CHECKBOX.isItemClicked(0, component.state)
    || component.state.loading;

  const error_style = {
    fontWeight: "bold",
    color: "red",
  }
  const error_text = component.state.customer_error || " ";
  const error = (
    <div align={"center"} style={{paddingTop: "1rem"}}>
      <span style={error_style}>{error_text}</span>
    </div>
  )


  return (
    <DashboardContainer
      client={props.client}
      title={"Electronic Payment"}>
      <div style={{width: "50%"}}>
        <GreyBox>
          <div style={{display: "flex", alignItems: "center", paddingBottom: "1rem"}}>
            <div>
              {DWOLLA_CHECKBOX.renderCheckbox(0, component) }
            </div>
            <div style={{paddingLeft: "2rem"}}>
              <DwollaTOS/>
            </div>
          </div>
          { dump_text(FIRST_NAME) }
          { dump_text(LAST_NAME) }
          { dump_text(EMAIL) }
        </GreyBox>
      </div>
      <div align={"center"} style={{paddingTop: "2rem"}}>
        <Action disabled={disable_command} onClick={on_create(component)}>
          <TextLoading
            label={"Login securely to your bank"}
            loading={component.state.loading}/>
        </Action>
      </div>
      { error }
    </DashboardContainer>
  );
}

const mapDispatchToProps = dispatch => {
  return {
  };
}

const mapStateToProps = state => {
  return {
    client: state.client,
    user: state.user,
  };
}

const create_customer_state = component => {
  const user = component.props.user;
  const state = {};
  const app_state = {
    FIRST_NAME: user.first_name,
    LAST_NAME: user.last_name,
    EMAIL: user.email,
  }
  ALL_PRMS.init(state, app_state, component);
  EMAIL.setDisabled(state, true);
  state.customer_error = "";
  return state;
}

const CreateCustomer = connect(mapStateToProps, mapDispatchToProps)(CreateCustomer_);

export { CreateCustomer, create_customer_state };
